module.exports = __webpack_public_path__ + "img/资源 68.c16418a3.png";